import React, { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button as UIButton } from "@/components/ui/button";
import { X } from "lucide-react";
import { useDashboardLayout } from "@/contexts/DashboardLayoutContext";

interface DashboardWidgetProps {
  id: string;
  title: string;
  children: ReactNode;
  className?: string;
  headerActions?: ReactNode;
}

export const DashboardWidget: React.FC<DashboardWidgetProps> = ({
  id,
  title,
  children,
  className = "",
  headerActions,
}) => {
  const { isCustomizing, toggleWidget } = useDashboardLayout();

  return (
    <Card className={`w-full ${className}`}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 px-3 sm:px-6 py-3 sm:py-4">
        <CardTitle className="text-sm sm:text-base font-medium flex items-center gap-2">
          {title}
        </CardTitle>
        <div className="flex items-center gap-1 sm:gap-2">
          {headerActions}
          {isCustomizing && (
            <UIButton
              variant="ghost"
              size="sm"
              onClick={() => toggleWidget(id)}
              className="h-6 w-6 sm:h-8 sm:w-8 p-0 text-gray-400 hover:text-red-500"
              title="Hide widget"
            >
              <X className="h-3 w-3 sm:h-4 sm:w-4" />
            </UIButton>
          )}
        </div>
      </CardHeader>
      <CardContent className="px-3 sm:px-6 pb-3 sm:pb-6 overflow-auto">
        {children}
      </CardContent>
    </Card>
  );
};

export default DashboardWidget;
